import { lazy } from "react";

const Card = lazy(() => import("@views/Service/Card"))
const FoodMenu = lazy(() => import("@views/Service/FoodMenu"))
const LibraryCatalog = lazy(() => import("@views/Order/Book/LibraryCatalog"))


const ServiceRoutes = [
    {
        path: 'service/card',
        element: <Card/>
    },
    {
        path: 'service/food',
        element: <FoodMenu/>
    },
    {
        path: 'order/book/libraryCatalog',
        element: <LibraryCatalog/>
    }
]
export default ServiceRoutes
